import type { AssetStatus } from '@peritasai/types';

export const ASSET_STATUS_LABEL_KEYS: Record<AssetStatus, string> = {
  AVAILABLE: 'pages.caseCartAssembly.progressScreen.assetStatusLabels.available',
  ALLOCATED: 'pages.caseCartAssembly.progressScreen.assetStatusLabels.allocated',
  RESERVED: 'pages.caseCartAssembly.progressScreen.assetStatusLabels.reserved',
  ASSEMBLED: 'pages.caseCartAssembly.progressScreen.assetStatusLabels.assembled',
  IN_ASSEMBLY: 'pages.caseCartAssembly.progressScreen.assetStatusLabels.inAssembly',
  UNAVAILABLE: 'pages.caseCartAssembly.progressScreen.assetStatusLabels.unavailable',
  DECON: 'pages.caseCartAssembly.progressScreen.assetStatusLabels.decon',
  OFF_RACK: 'pages.caseCartAssembly.progressScreen.assetStatusLabels.offRack',
  CHECK_IN: 'pages.caseCartAssembly.progressScreen.assetStatusLabels.checkIn',
  CHECKING_IN: 'pages.caseCartAssembly.progressScreen.assetStatusLabels.checkingIn',
  CHECKED_IN: 'pages.caseCartAssembly.progressScreen.assetStatusLabels.checkedIn',
};

// Frontend-only ordering — the backend does not define one.
export const ASSET_STATUS_PRIORITY_ORDER: AssetStatus[] = [
  'AVAILABLE',
  'ASSEMBLED',
  'IN_ASSEMBLY',
  'UNAVAILABLE',
  'RESERVED',
  'ALLOCATED',
  'CHECK_IN',
  'CHECKING_IN',
  'CHECKED_IN',
  'DECON',
  'OFF_RACK',
];

// Returns the unit itself (not just its status) so its location can also be
// shown alongside the status label on a pending card.
export const resolvePriorityStatusAsset = <
  T extends { status: AssetStatus | null | undefined }
>(
  assets: T[]
): T | null => {
  const firstByStatus = new Map<AssetStatus, T>();
  assets.forEach((asset) => {
    if (asset.status && !firstByStatus.has(asset.status)) {
      firstByStatus.set(asset.status, asset);
    }
  });
  for (const status of ASSET_STATUS_PRIORITY_ORDER) {
    const match = firstByStatus.get(status);
    if (match) return match;
  }
  return null;
};
